export { DesignSystemModule } from './design-system.module';
export { DesignSystemRoutingModule } from './design-system-routing.module';
